import React, { useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";

import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import FeedbackFormDialog from "./feedback/feedbackFormDialog";

import { useEnv } from "./contexts/envContext";

const InfoDialog = ({ infoDialogOpen, setInfoDialogOpen }) => {
    const [feedbackButtonClicked, setFeedbackButtonClicked] = useState(false);

    const { feedbackFormEnabled } = useEnv();

    const handleDownloadUserManualClick = () => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/pdf" }
        };
        fetch("./static/files/CMP_UI_User_Manual_v1.1.8.pdf", requestOptions)
            .then((response) => response.blob())
            .then((blob) => downloadUserManual(blob))
            .catch((err) => console.error(err));
    };
    const downloadUserManual = (blob) => {
        const file = URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = file;
        link.download = "CMP User Manual.pdf";
        document.body.appendChild(link);

        const mouseEvent = new MouseEvent("click", { bubbles: true, cancelable: true, view: window });
        link.dispatchEvent(mouseEvent);
        document.body.removeChild(link);
    };
    const handleOpenFeedbackForm = () => {
        setFeedbackButtonClicked(true);
    };
    const handleCloseDialog = () => {
        setInfoDialogOpen(false);
    };
    return (
        <Dialog open={infoDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
            {feedbackButtonClicked ? (
                <FeedbackFormDialog setFeedbackButtonClicked={setFeedbackButtonClicked} setInfoDialogOpen={setInfoDialogOpen} />
            ) : (
                <>
                    <DialogTitle component={"div"}>
                        <Typography variant="h6" gutterBottom>
                            {"System Information"}
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                            {["CMP Version 1.5.0", "UI Version 1.1.8"].map((label, i) => (
                                <Chip key={i} label={label} size="small" variant="outlined" sx={{ color: "#6b778c" }} />
                            ))}
                        </Box>
                    </DialogTitle>

                    <DialogContent>
                        {feedbackFormEnabled ? (
                            <DialogContentText color="text.primary">
                                {"Please download our current user manual or submit feedback to help improve to our system."}
                            </DialogContentText>
                        ) : (
                            <DialogContentText color="text.primary">{"Click below if you would like to download our current user manual."}</DialogContentText>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleCloseDialog} sx={{ mr: "auto" }}>
                            {"Close"}
                        </Button>
                        <Button onClick={handleDownloadUserManualClick} startIcon={<DownloadIcon />}>
                            {"User Manual"}
                        </Button>

                        {feedbackFormEnabled ? (
                            <Button onClick={handleOpenFeedbackForm} startIcon={<OpenInNewIcon />}>
                                {"Feedback Form"}
                            </Button>
                        ) : (
                            <></>
                        )}
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default InfoDialog;
